import { Box, Button, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ReactNode } from 'react';

interface FeatureRowProps {
  icon: ReactNode;
  title: string;
  description: string;
}

function FeatureRow({ icon, title, description }: FeatureRowProps) {
  return (
    <Box display="flex" alignItems="flex-start" gap={2}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: 'primary.50',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: 'primary.main',
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

interface StepWantsToStartProps {
  onGoToOpportunities: () => void;
  onExplore: () => void;
  isPending: boolean;
}

export default function StepWantsToStart({
  onGoToOpportunities,
  onExplore,
  isPending,
}: StepWantsToStartProps) {
  return (
    <Box textAlign="center">
      <Typography variant="h5" fontWeight={700} sx={{ mb: 1.5 }}>
        Perfecto, aquí empieza todo
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3.5 }}>
        En InversorHub encontrarás oportunidades de inversión reales, analizadas por profesionales.
      </Typography>

      <Box display="flex" flexDirection="column" gap={2.5} textAlign="left" sx={{ mb: 3.5 }}>
        <FeatureRow
          icon={<SearchIcon fontSize="small" />}
          title="Explora oportunidades"
          description="Operaciones reales filtradas y analizadas por PSIs profesionales"
        />
        <FeatureRow
          icon={<TrendingUpIcon fontSize="small" />}
          title="Analiza los números"
          description="Cada oportunidad incluye datos financieros para decidir con criterio"
        />
        <FeatureRow
          icon={<AddCircleOutlineIcon fontSize="small" />}
          title="Muestra tu interés"
          description="Si te encaja una oportunidad, indica tu interés y el PSI te contacta"
        />
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        onClick={onGoToOpportunities}
        disabled={isPending}
        sx={{ mb: 1 }}
      >
        {isPending ? 'Guardando...' : 'Ver oportunidades →'}
      </Button>

      <Button
        variant="text"
        size="small"
        fullWidth
        onClick={onExplore}
        disabled={isPending}
        sx={{
          color: 'text.secondary',
          textDecoration: 'underline',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        Prefiero explorar por mi cuenta
      </Button>
    </Box>
  );
}
